<template>
  <v-dialog v-model="visible" max-width="500px" >
    <!--<v-btn slot="activator" color="#000000" dark class="add-button mb-2">Lisää tuote</v-btn>-->
    <v-card>
      <v-card-title class="pl-3">
        <span class="headline">Muokkaa merkkaamoa</span>

      </v-card-title>
      <v-container grid-list-md class="py-12 pb-0 add-product-container">
        <!-- <div >Merkkaamo UUSI kentän voi myös jättää tyhjäksi jolloinka </div> -->
        <v-row wrap>
          <v-col cols="6" class="py-0 mb-3">
            <span style="font-size:12px;font-weight:600">Tuotetta tällä merkkamolla: <span style="font-size:16px;">{{numberOfProducts}}</span> </span>
            
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            
            
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-autocomplete
              autocomplete="off"
              label="Merkkaamo NYT"
              v-model="currentPrintShop"
              :items="getPrintShops"
              @change="v => v !== '' ? currentPrintShopError = '' : 'Valitse merkkaamo'"
              :error-messages="currentPrintShopError"
              placeholder=" "
              item-text="text"
              item-value="value"
              dense
            />
            
          </v-col>
          <v-col cols="6" class="py-0 my-0">
            <v-autocomplete
              autocomplete="off"
              label="Merkkaamo UUSI"
              v-model="newPrintShop"
              :items="getPrintShops"
              @change="v => v !== '' ? newPrintShopError = '' : 'Valitse merkkaamo'"
              :error-messages="newPrintShopError"
              placeholder=" "
              item-text="text"
              item-value="value"
              dense
            />
          </v-col>
          
                  
          
        </v-row>
      </v-container>
      <v-card-actions class="pt-12">
        <v-spacer></v-spacer>
        <v-btn color="avecor-button-global add-button mb-2" @click="visible = false">Peruuta</v-btn>
        <v-btn color="avecor-button-global add-button mb-2" @click="modifyPrintShop" >Muokkaa </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    props:[],
    data: () => ({
      autogrow:true,
      currentPrintShop:'',
      newPrintShop:'',
      currentPrintShopError:'',
      newPrintShopError:'',
    }),
    mounted() {
    },
    watch: {
      visible:{
        handler(val) {
          if(!val) {
            this.currentPrintShop = ''
            this.newPrintShop = ''
            this.currentPrintShopError = ''
            this.newPrintShopError = ''
          }
        }
      }
    },
    computed: {
      numberOfProducts(){
        var total = 0
        if(this.currentPrintShop){
           Object.keys(this.products).forEach(pId => {
            var p = this.products[pId]
            if(p.printShops && Array.isArray(p.printShops) && p.printShops.includes(this.currentPrintShop)){
              total += 1
            }
           })
        }
        return total
      },
      getPrintShops(){
        
        var printShops = this.printShops
        var shops = Object.keys(this.printShops).map(function(key, index) {
          var p = printShops[key]
          return {text: p.name, value: p.id}
        })
        return shops.sort((a,b)=>{
          var nameA= a.text.toLowerCase(), nameB=b.text.toLowerCase();
          if (nameA > nameB) {return 1;}
          if (nameB > nameA) {return -1;}
          return 0;
        })

      },
      ...mapFields([
        "settings",
        "modals.product.bulkEdit.visible",
        "printShop.printShops",
        "product.products"

      ])
    },
    created () {},
    methods: {
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
      },
      modifyPrintShop(){
        var errors = false
        if(!this.currentPrintShop) {
          this.currentPrintShopError = 'Valitse Merkkaamo'
          errors = true
        }
        if(!this.newPrintShop) {
          this.newPrintShopError = 'Valitse Merkkaamo'
          errors = true
        }
        if(errors) return
        var np = 0
        Object.keys(this.products).forEach(pId => {
          var p = this.products[pId]
          if(p.printShops && Array.isArray(p.printShops)){
            if(p.printShops.includes(this.currentPrintShop)) {
              if(np < 400){
                var newPrintShops = p.printShops.filter(ps => ps !== this.currentPrintShop)
                if(this.newPrintShop && !p.printShops.includes(this.newPrintShop)) newPrintShops.push(this.newPrintShop)
                //console.log(newPrintShops)
                this.$store.dispatch('product/set', {
                  id:p.id,
                  printShops:newPrintShops
                })
              }
              np = np + 1
            }
          }
        })
        if(np >= 400) alert('Kaikkia tuotteita ei pysty kerralla muokkaamaan (yli 400 tuotetta). Klikkaa uudestaan "muokkaa merkkaamoa" painiketta.')
        else {
          this.visible = false
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:2500, snackText:"Muokattu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        //console.log(np)
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/BulkProductEdit.vue